import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { globalData, ADD, EDIT, VIEW, CLIENT, SPOUSE, NORMAL, CHILD } from '../../../../common/common';
import { clone, getAge } from '../../../../common/utils';
import InputDO from '../InputsSingle/InputDO';
import Input1 from '../InputsSingle/Input1';
import Input2 from '../InputsSingle/Input2';
import Input3 from '../InputsSingle/Input3';
import Input4 from '../InputsSingle/Input4';
import Input5 from '../InputsSingle/Input5';
import Input6 from '../InputsSingle/Input6';
import Input7 from '../InputsSingle/Input7';

const Root = styled(Box)({
    width: '100%',
    maxHeight: '600px',
    '& .contentTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#212C31',
    },
    '& .wapper': {
        padding: '10px 15px',
        cursor: 'pointer',
        '& .icon': {
            visibility: 'hidden',
        },
    },
    '& .wapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
    },
    '& .wapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
        '& .icon': {
            visibility: 'visible',
            color: '#fff',
        },
    },
})

class EstateContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            note: "",
            allData: {},
            btnName: this.btnName(this.props.state)
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.setToDoc = this.setToDoc.bind(this);
        this.setToAllData = this.setToAllData.bind(this);
        this.updateInfoToAllData = this.updateInfoToAllData.bind(this);
        this.uploadChildNormalToAllData = this.uploadChildNormalToAllData.bind(this);
        this.delChildToAllData = this.delChildToAllData.bind(this);
        this.doNext = this.doNext.bind(this);
    }
    render() {
        const {
            name,
            note,
            allData,
        } = this.state;
        const { menuData, menuIndex, dragData, state } = this.props;
        const contentView = () => {
            if (menuIndex === 0) {
                return <InputDO
                    name={name}
                    note={note}
                    ref={(child) => { this.input_doc = child }}
                    setToDoc={this.setToDoc}
                />
            } else if (menuIndex === 1) {
                return <Input1
                    state={state}
                    data={allData["INFO"]}
                    ref={(child) => { this.input_1 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                />
            } else if (menuIndex === 2) {
                return <Input2
                    state={state}
                    data={allData["CHILD"]}
                    ref={(child) => { this.input_2 = child }}
                    setToAllData={this.setToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                    delChildToAllData={this.delChildToAllData}
                />
            } else if (menuIndex === 3) {
                return <Input3
                    state={state}
                    data={allData["EXECUTOR"]}
                    dragData={dragData}
                    ref={(child) => { this.input_3 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 4) {
                return <Input4
                    state={state}
                    data={allData["GU"]}
                    dragData={dragData}
                    ref={(child) => { this.input_4 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 5) {
                return <Input5
                    state={state}
                    data={allData["POA"]}
                    dragData={dragData}
                    ref={(child) => { this.input_5 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 6) {
                return <Input6
                    state={state}
                    data={allData["LW"]}
                    dragData={dragData}
                    ref={(child) => { this.input_6 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            } else if (menuIndex === 7) {
                return <Input7
                    state={state}
                    data={allData["TRUSTEE"]}
                    dragData={dragData}
                    ref={(child) => { this.input_7 = child }}
                    setToAllData={this.setToAllData}
                    updateInfoToAllData={this.updateInfoToAllData}
                    uploadChildNormalToAllData={this.uploadChildNormalToAllData}
                />
            }
        }
        return (
            <Root>
                <div className="contentTitle">{menuData[menuIndex]}</div>
                {contentView()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, contentData } = this.props;
        if (state === VIEW || state === EDIT) {
            this.setState(() => ({
                name: contentData.name,
                note: contentData.notes,
                allData: contentData.content
            }))
            let obj = contentData.content["CHILD"];
            let haveNonage = false;
            if (!obj) return;
            for (const iterator of obj) {
                const age = getAge(iterator["DOB"])
                if (age < 18) {
                    haveNonage = true;
                }
            }
            globalData.haveNonage = haveNonage;
        } else {
            globalData.haveNonage = true;
        }
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleClick(e, index) {
        this.setState(() => ({
            menuIndex: index
        }))
    }
    setToAllData(name, value, callback = null) {
        const { allData } = this.state;
        allData[name] = value;
        if (name === "INFO") {
            allData["INFOS"] = this.extractInfoToArr(value);
        }
        this.setState({
            allData
        }, () => {
            if (callback) callback();
            this.props.handleChange(name, value);
        })
    }
    //update child or normal
    uploadChildNormalToAllData(value) {
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (arr instanceof Array) {
                    for (const obj of arr) {
                        if (obj.type === value.type && obj.id === value.id) {
                            Object.assign(obj, value);
                            if (obj.hasOwnProperty("N.")) {
                                obj[".CHO.N."] = value["N."];
                                obj[".CHO.AddrNPho"] = value["AddrNPho"];
                            }
                        }
                    }
                }
            }
        }
        console.log("uploadChildNormalToAllData alldata", allData);
        this.setState({
            allData
        }, () => {
            this.props.handleChange("", value);
        })
    }
    delChildToAllData(id){
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (arr instanceof Array) {
                    for (const obj of arr) {
                        if (obj.id === id) {
                            const index = arr.indexOf(obj);
                            arr.splice(index,1);
                        }
                    }
                }
            }
        }
        this.setState({
            allData
        }, () => {
            this.props.handleChange("", null);
        })
    }
    updateInfoToAllData() {
        const allData = clone(this.state.allData);
        for (const key in allData) {
            if (Object.hasOwnProperty.call(allData, key)) {
                const arr = allData[key];
                if (key !== "INFO") {
                    for (const obj of arr) {
                        //根据"type"字段判断每项中是否含有Client或spouse信息
                        if (Object.hasOwnProperty.call(obj, "type")) {
                            if (obj.type === CLIENT) {
                                const clientInfo = globalData.clientInfo;
                                obj[".CHO.Addr"] = clientInfo[".CHO.Addr"];
                                obj[".CHO.AddrNPho"] = clientInfo[".CHO.AddrNPho"];
                                obj[".CHO.Em"] = clientInfo[".CHO.Em"];
                                obj[".CHO.N."] = clientInfo[".CHO.N."];
                                obj[".CHO.R.C."] = clientInfo[".CHO.R.C."];
                                obj["P.H.Pho"] = clientInfo["P.H.Pho"];
                                obj["P.W.Pho"] = clientInfo["P.W.Pho"];
                                obj["rc"] = clientInfo["rc"];
                                obj["relation"] = clientInfo["relation"];
                            }
                        }
                    }
                }
            }
        }
        console.log("updateInfoToAllData alldata", allData);
        this.setState({
            allData
        })
    }
    extractInfoToArr(data) {
        //phone;unit;street;city;state;zipcode
        let addrObjP = data["P.H.Addr"];
        console.log(data)
        addrObjP["phone"] = data["P.H.Pho"];
        let rcP = (data["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        let clientObj = clone(data);
        clientObj[".CHO.N."] = data["P.F.Name"];
        clientObj[".CHO.R.C."] = rcP;
        clientObj[".CHO.AddrNPho"] = addrObjP;
        clientObj["id"] = "1";
        clientObj["type"] = CLIENT;
        const arr = [clientObj];
        return arr;
    }
    setToDoc(name, value) {
        this.setState(() => ({
            [name]: value
        }))
    }
    doNext() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
            return this.input_doc.doNext();
        } else if (menuIndex === 1) {
            return this.input_1.doNext();
        } else if (menuIndex === 2) {
            return this.input_2.doNext();
        } else if (menuIndex === 3) {
            return this.input_3.doNext();
        } else if (menuIndex === 4) {
            return this.input_4.doNext();
        } else if (menuIndex === 5) {
            return this.input_5.doNext();
        } else if (menuIndex === 6) {
            return this.input_6.doNext();
        } else if (menuIndex === 7) {
            return this.input_7.doNext();
        }
    }
    getData() {
        const {
            name,
            note,
            allData
        } = this.state;
        let obj = {
            name,
            note,
            content: allData
        }
        return obj;
    }
    getContentRectData() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_3.getContentRectData();
        } else if (menuIndex === 4) {
            return this.input_4.getContentRectData();
        } else if (menuIndex === 5) {
            return this.input_5.getContentRectData();
        } else if (menuIndex === 6) {
            return this.input_6.getContentRectData();
        } else if (menuIndex === 7) {
            return this.input_7.getContentRectData();
        }
        return null;
    }
    handleCollision() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_3.handleCollision();
        } else if (menuIndex === 4) {
            return this.input_4.handleCollision();
        } else if (menuIndex === 5) {
            return this.input_5.handleCollision();
        } else if (menuIndex === 6) {
            return this.input_6.handleCollision();
        } else if (menuIndex === 7) {
            return this.input_7.handleCollision();
        }
    }
    handleLeave() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_3.handleLeave();
        } else if (menuIndex === 4) {
            return this.input_4.handleLeave();
        } else if (menuIndex === 5) {
            return this.input_5.handleLeave();
        } else if (menuIndex === 6) {
            return this.input_6.handleLeave();
        } else if (menuIndex === 7) {
            return this.input_7.handleLeave();
        }
    }
    handleUp() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_3.handleUp();
        } else if (menuIndex === 4) {
            return this.input_4.handleUp();
        } else if (menuIndex === 5) {
            return this.input_5.handleUp();
        } else if (menuIndex === 6) {
            return this.input_6.handleUp();
        } else if (menuIndex === 7) {
            return this.input_7.handleUp();
        }
    }
    handleDown() {
        const { menuIndex } = this.props;
        if (menuIndex === 0) {
        } else if (menuIndex === 1) {
        } else if (menuIndex === 2) {
        } else if (menuIndex === 3) {
            return this.input_3.handleDown();
        } else if (menuIndex === 4) {
            return this.input_4.handleDown();
        } else if (menuIndex === 5) {
            return this.input_5.handleDown();
        } else if (menuIndex === 6) {
            return this.input_6.handleDown();
        } else if (menuIndex === 7) {
            return this.input_7.handleDown();
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default EstateContent;